module.exports = __webpack_public_path__ + "static/img/candies-banner.ad2a17fb.png";